import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Card Component
 *
 * Basic card container with v2 design system styling
 * Includes hover effects and elevation options
 *
 * @param {boolean} elevated - Whether card has shadow elevation
 * @param {boolean} noPadding - Whether to remove default padding
 * @param {function} onClick - Click handler (makes card clickable)
 * @param {React.ReactNode} children - Card content
 */
const V2Card = ({
  elevated = false,
  noPadding = false,
  onClick,
  className = '',
  children,
  ...props
}) => {
  const cardClasses = [
    'v2-card',
    elevated ? 'v2-card-elevated' : '',
    noPadding ? 'v2-card-no-padding' : '',
    onClick ? 'v2-card-clickable' : '',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  const handleKeyPress = (e) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick(e);
    }
  };

  const CardElement = onClick ? 'div' : 'div';
  const interactiveProps = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onClick: handleClick,
        onKeyPress: handleKeyPress
      }
    : {};

  return (
    <CardElement
      className={cardClasses}
      {...interactiveProps}
      {...props}
    >
      {children}
    </CardElement>
  );
};

export default V2Card;
